import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";

function CustomDropzone(props) {
  const baseStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: props.width,
    height: "173px",
    border: "1px dashed #dfdfdf",
    borderRadius: "20px",
    marginTop: props.marginTop || 0,
  };

  const focusedStyle = {
    border: "1px dashed #00e1be",
  };

  const rejectStyle = {
    border: "1px dashed #ff6666",
  };

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      onDrop: props.onDrop,
      accept: props.accept,
    });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused || isDragAccept ? focusedStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <div {...getRootProps({ style })} className="dropzone-container">
      <i className="material-icons">cloud_upload</i>
      <input {...getInputProps({ name: 'file' })} />
      <p>Arrastra o selecciona tu archivo</p>
    </div>
  );
}


export default CustomDropzone;
